import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    appId: "1:1082203037131:web:25067ed5af2915ab1f2a4e",
    storageBucket: "cardio-9b62e.firebasestorage.app",
    apiKey: "AIzaSyAxxeCfjsb1Sgd06ThOJpifxu3NB4cu-Dk",
    authDomain: "cardio-9b62e.firebaseapp.com",
    messagingSenderId: "1082203037131",
    measurementId: "G-7ETB921C5L",
    projectId: "cardio-9b62e"
};

let messaging = null;
const initFirebase = (formattedMacs) => {
  const firebaseApp = initializeApp(firebaseConfig);
  messaging = getMessaging(firebaseApp);

  requestPermissions(formattedMacs);
  onMessage(messaging, (payload) => {
    _log(`Foreground Notification Received: ${payload}`);
    alert(`${payload?.notification?.title}!\n${payload?.notification?.body}`);
    new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: payload.notification.icon,
    });
  });
}

const requestPermissions = async (formattedMacs) => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        _log("Notification permission granted.");

        /* Check for Existing FCM token */
        let existingToken = localStorage.getItem("fcm_token");
        if (existingToken) {
          _log(`✅ Existing FCM Token: ${existingToken}`);
          if (existingToken) {
            subscribeToTopic(existingToken, formattedMacs);
          }
          return existingToken;
        }
        
        // Get new FCM Token
        getToken(messaging, {
          vapidKey: 'BFyl6muYysEAIzf90F1tI8zg-cL4-kgA7fJsSxJ2DoqigmpbGOSpNQPTfObxX9Ma3eySvRQBQSbbDg7QyYTc6hc'
        }).then((currentToken) => {
            if (currentToken) {
                _log(`🔑 FCM Token: ${currentToken}`);
                localStorage.setItem("fcm_token", currentToken);
                if (currentToken) {
                  subscribeToTopic(currentToken, formattedMacs);
                }
            } else {
              _log("❌ No registration token available.");
            }
        })
        .catch((err) => console.error("FCM Token Error:", err));
      } else {
        _log("Permission denied for notifications.");
      }
    } catch (error) {
      console.error("[FIREBASE] - Error requesting notification permission:", error);
    }
};


const subscribeToTopic = async (token, topics) => {
  try {
    let subscribedTopics = JSON.parse(localStorage.getItem("subscribed_topics")) || [];
    const newTopics = topics.filter(topic => !subscribedTopics.includes(topic));

    if (!newTopics.length) {
      _log("🔄 Already subscribed to all topics.");
      return;
    }

    const response = await fetch(`https://subscribetotopic-ydjujct5fq-uc.a.run.app`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, topic: newTopics }),
      }
    );
    const data = await response.json();
    if (response.ok) {
      _log(`Subscribed to topic: ${newTopics.join(", ")}`);
      subscribedTopics.push(...newTopics);
      localStorage.setItem("subscribed_topics", JSON.stringify(subscribedTopics));
    } else {
      _log("❌ Failed to subscribe to topic");
    }
  } catch (error) {
    console.error("[FIREBASE] - Error subscribing to topic", error);
  }
};

const _log = (message) => {
  console.log(`[🎉 Firebase Log 🎉] - ${message}`);
}

export { getToken, onMessage, requestPermissions, initFirebase };